/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   RentableUtils
 */

import { PropertyType } from '@zcode/enums'
import type { Listable, Pin, Property } from '@zcode/state-type'
import { BUNGALOW } from '../../../../shared/constants/source'

export const isRoomForRent = (
  item: Pick<Listable | Property | Pin, 'feedName' | 'propertyType'>
) => {
  return (
    item.propertyType === PropertyType.ROOM ||
    item.propertyType === PropertyType.SHARED_ROOM ||
    item.feedName === BUNGALOW
  )
}
